







































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { Fields, Group, Provider } from '@/common/ClaimsForm';

import { statesList } from '@/utils/Utils';

// Components
import SelectField from '@/components/Form/SelectField.vue';
import TextField from '@/components/Form/TextField.vue';
import RadioField from '@/components/Form/RadioField.vue';
import ClaimFormButton from './ClaimFormButton.vue';

interface Option {
	id: string;
	name: string;
}

@Component({
	name: 'InvolvedInsuredsHealthCareProvidersProviderFields',
	components: {
		ClaimFormButton,
		RadioField,
		SelectField,
		TextField,
	},
})
export default class InvolvedInsuredsHealthCareProvidersProviderFields extends Vue {
	@Prop() private values: Fields;
	@Prop() private input: any;
	@Prop() private blur: any;
	@Prop() private errors: any;
	@Prop() private touched: any;

	@State('emptyProvider', { namespace: 'ClaimsForm' }) private emptyProvider: Provider;

	private statesList: typeof statesList = statesList;

	private addProvider() {
		this.values.involvedInsuredsHealthCareProviders.providers.push(
			Object.assign({}, this.emptyProvider),
		);
	}

	private removeProvider(index) {
		this.values.involvedInsuredsHealthCareProviders.providers = this.values.involvedInsuredsHealthCareProviders.providers.filter(
			(provider, i) => i !== index,
		);
	}

	private getSameAsOptions(
		sameAs: 'sameAddressAs' | 'sameContactAs',
		forProviderIndex: number,
	): Option[] {
		// Declare functions that format a group/provider option name if and only if all necessary
		// fields have been supplied.
		function formatGroupAddressName(group: Group): string | undefined {
			return (
				group.groupName &&
				group.streetAddress &&
				[`Entity - ${group.groupName}`, group.streetAddress].join(' | ')
			);
		}
		function formatGroupContactName(group: Group): string | undefined {
			return (
				group.groupName &&
				group.phonePreference &&
				group.phoneNumber &&
				group.emailAddress &&
				[
					`Entity - ${group.groupName}`,
					`${group.phonePreference} - ${group.phoneNumber}`,
					group.emailAddress,
				].join(' | ')
			);
		}

		function formatProviderAddressName(
			provider: Provider,
			providerIndex: number,
		): string | undefined {
			return (
				provider.firstName &&
				provider.lastName &&
				provider.streetAddress &&
				[
					`Provider #${providerIndex + 1} - ${provider.firstName} ${provider.lastName}`,
					provider.streetAddress,
				].join(' | ')
			);
		}
		function formatProviderContactName(
			provider: Provider,
			providerIndex: number,
		): string | undefined {
			return (
				provider.firstName &&
				provider.lastName &&
				provider.phonePreference &&
				provider.phoneNumber &&
				provider.emailAddress &&
				[
					`Provider #${providerIndex + 1} - ${provider.firstName} ${provider.lastName}`,
					`${provider.phonePreference} - ${provider.phoneNumber}`,
					provider.emailAddress,
				].join(' | ')
			);
		}

		// Select the appropriate functions from above.
		let formatGroupOptionName: (group: Group) => string | undefined;
		let formatProviderOptionName: (
			provider: Provider,
			providerIndex: number,
		) => string | undefined;
		switch (sameAs) {
			case 'sameAddressAs':
				formatGroupOptionName = formatGroupAddressName;
				formatProviderOptionName = formatProviderAddressName;
				break;

			case 'sameContactAs':
				formatGroupOptionName = formatGroupContactName;
				formatProviderOptionName = formatProviderContactName;
				break;

			default:
				throw new Error(`Unhandled \`sameAs\` argument: '${sameAs}'`);
		}

		// Build and return the list of options.
		const options: Option[] = [];

		const reportingForAAN = this.values.insuredsPolicyInformation.reportingForAAN;
		if (reportingForAAN === 'Both' || reportingForAAN === 'Group') {
			const group: Group | undefined = this.values.involvedInsuredsHealthCareProviders.group;
			const groupOptionName: string | undefined = group && formatGroupOptionName(group);
			if (groupOptionName) {
				options.push({
					id: 'group',
					name: groupOptionName,
				});
			}
		}

		if (reportingForAAN === 'Both' || reportingForAAN === 'Individual') {
			const providers: Provider[] =
				this.values.involvedInsuredsHealthCareProviders.providers ?? [];
			providers.forEach((provider: Provider, providerIndex: number): void => {
				const providerOptionName: string | undefined =
					providerIndex !== forProviderIndex && !provider[sameAs]
						? formatProviderOptionName(provider, providerIndex)
						: undefined;
				if (providerOptionName) {
					options.push({
						id: `provider${providerIndex}`,
						name: providerOptionName,
					});
				}
			});
		}

		return options;
	}
}
